"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _EditorialErrorMessage = require("./EditorialErrorMessage");
Object.keys(_EditorialErrorMessage).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _EditorialErrorMessage[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _EditorialErrorMessage[key];
        }
    });
});
var _types = require("./types");
Object.keys(_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _types[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _types[key];
        }
    });
});
